<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="380">
    <v-card>
        <v-toolbar dense class="mb-4" color="primary" dark>
            ADD EMPTY ITEM
           <v-spacer/>
           <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
           <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <!-- <v-autocomplete
                  v-model="supplier"
                  label="SUPPLIER"
                  :items="$store.state.suppliers"
                  item-text="company"
                  item-value="id"
                  dense
                  outlined
                  filled
                /> -->
              <v-autocomplete
                  v-model="product.product_code"
                  label="Product code"
                    :rules="textRules"
                    required
                  dense
                  item-text="code"
                  item-value="code"
                  outlined
                  :items="EMPTIES"
                  persistent-hint
                  :hint="ITEM.description"
                />

                 <v-text-field 
                 :disabled="true"
                 :value="ITEM.price_per_unit"
                  label="Unit Price"
                  dense
                  outlined
                />
                 <v-text-field 
                 v-model="product.refund"
                  label="Refund Quantity"
                  type="number"
                   :rules="textRules"
                    required
                  requir
                  dense
                  outlined
                />
           </v-form>
        </v-card-text>
         
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  small color="success" rounded depressed  @click="validate()"><v-icon small left>mdi-check</v-icon>ADD</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapMutations
} from 'vuex'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    method: {
      type: String,
      default:''
    },
    itemid: {
      type: Number,
      default:0
    },
    customer: {
      type: Number,
      default:0
    }
  },
  data: () => ({
    valid: true,
    product_list:[],
    supplier:0,
      product:{},
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
    
      EMPTIES(){
        var lists = this.$store.state.products
        var arr =  lists.reduce((res, item)=>{
            if(item.type=="empties") {
                res.push(item)
            }
            return res
        },[])
        return arr
      },
      ITEM(){
        var arr =  this.EMPTIES.reduce((res, item)=>{
            if(item.code==this.product.product_code) {
                res = item
            }
            return res
        },{})
        return arr
      }
  },
  watch: {
    show(v) {
      if(v) {
        this.product = {}
        if(this.method=='sales') {
          this.getProductLists()
        }
      }
    }
  },
  methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText']),
    emitToParent (action) {
        this.$emit('DialogEvent',action)
    },
  validate () {
        if (this.$refs.form.validate()) {
          var endpoint = ''
          this.product.unit_price = this.ITEM.price_per_unit
          this.product.description = this.ITEM.description
          this.product.type="container"
          this.product.refund =this.product.refund.toString()
          if(this.method == 'purchase') {
              this.product.po=this.itemid
              endpoint = "purchase/add_item"
          } else if(this.method=="sales"){
            this.product.refund =this.$IsNum(this.product.refund)
            this.product.sales_id=this.itemid
             this.product.unit_price = this.ITEM.price_per_unit.toString()
             endpoint = "sales/add_item"
          } else if(this.method=="delivery"){
             this.product.delivery_id=this.itemid
              endpoint = "delivery/add_item"
          }
          this.AddItem(endpoint)
        }
      },
    AddItem(endpoint){
      console.log(this.product)
       this.$http.post(endpoint, this.product).then(response => {
            this.GET_RESPONSE(response)
           this.$emit('DialogEvent', "close")
          }).catch(e => {
            console.log(e.data)
        }) 
    },
    getProductLists(){
        this.$http.post("customer/product_lists", {id: this.customer}).then(response => {
              response.data.items !=null?this.product_list = response.data.items:this.product_list = []
              }).catch(e => {
              console.log(e.data)
          })
    }
  }
}
</script>
